import AccordionList from "../components/AccordionList";
import Footer from "../components/Footer";
import Sidebar from "../components/Sidebar";
import { Helmet } from "react-helmet";
import { NavLink } from "react-router-dom";
import TestimonialGrid from "../components/TestimonialGrid";

export default function HolidayMasterclasses() {
  const testi = [
    {
      name: "Jing En Tan",
      rating: 5,
      feedback: (
        <>
          <p className="my-2">
            How will you like to take your public speaking skills to the next
            level in a few months without having to fear standing on stage to
            present to an audience again? Public Speaking Academy has a
            professional team full of experience, ready to help you improve your
            public speaking skills tremendously. Having attended many of Public
            Speaking Academy's lessons before, all of their lessons are
            extremely engaging and the trainers will always be there to give you
            the guidance and advice you need. Most importantly, their strong
            belief is that being a good speaker comes not from nature, but
            nurture, providing all the opportunities to grow and improve as a
            speaker. Feel free to drop them an email to find out more and take
            the first step to improving your public speaking skills!
          </p>
        </>
      ),
    },
    {
      name: "Jing Kai Tan",
      rating: 5,
      feedback: (
        <>
          <p className="my-2">
            When I first came across PSA, I too had my reservations on how
            relevant Mr Darren and his public speaking course would be for me.
            Having attended numerous public speaking courses before and hosted
            events in school, I questioned the need to attend this course.
            However, as my brother was signing up for it, I decided to tag along
            with him.
            <br />
            <br /> This course has been so eye-opening for me. Being someone
            with a decent amount of experience in public speaking, I was exposed
            to so much more skills, tricks and ways to host and conduct myself
            in front of a crowd. I learnt so much from this course, and I am
            indeed very thankful to have met such a great mentor like Mr Darren.
          </p>
        </>
      ),
    },
    {
      name: "aria boon",
      rating: 5,
      feedback: (
        <>
          <p className="my-2">
            I think that this experience at the Public Speaking Academy was
            truly wonderful. I used to be shy and did not dare to voice my
            opinions, but now I am able to confidently share my thoughts. I
            learnt so many techniques (eg. PEEL, SLE ) and they have benefited
            me in many ways. I could pass majority of my interviews with these
            techniques. I would highly recommend to go for a class at the Public
            Speaking Academy!
          </p>
        </>
      ),
    },
    {
      name: "Justin Lu (Parent of Elizabeth & Charlotte)",
      rating: 5,
      feedback: (
        <>
          <p className="my-2">
            Knowing PSA about 1.5 years, it was a fantastic experience. Thank
            you Mr Darren for your professional coaching and guidance. Thank you
            Mr Jeremy for your patience and support! Wonderful team which will
            never let you down! Wish you guys all the best! And Wish PSA all the
            best!
          </p>
        </>
      ),
    },
    // Add more testimonials as needed
  ];

  const faqData = [
    {
      title:
        "Which public speaking classes in Singapore help shy kids build confidence for school presentations?",
      content: (
        <>
          <p className="p-1 text-lg font-bold">
            🧠 From Shy to Confident Speakers
          </p>
          <p className="p-1">
            At Public Speaking Academy Singapore, we specialize in nurturing shy
            and soft-spoken children. Through drama-inspired techniques, team
            activities, and personalized coaching, students gradually overcome
            stage fright and anxiety. Our modules help kids feel comfortable
            speaking in front of their classmates — perfect preparation for
            school presentations and oral exams.
          </p>
        </>
      ),
    },
    {
      title:
        "Are there any public speaking programs for kids & teenagers that prepare them for DSA or scholarship interviews in Singapore?",
      content: (
        <>
          <p className="p-1 text-lg font-bold">
            🎓 DSA & Scholarship Interview Preparation
          </p>
          <p className="p-1">
            Our teen public speaking tracks include interview simulations
            designed specifically for Singapore’s DSA and scholarship pathways.
            Students learn how to structure answers, showcase leadership
            potential, and speak confidently under pressure. Sessions are
            aligned with current MOE expectations and real student experiences.
            Speech Excellence Program™ & S’Peak Performance Kids Holiday
            Program™ teach interview skills in one of the 12 monthly modules &
            2-day modules respectively, whilst Interview Skills Mastery™ devotes
            the entire training to interview skills.
          </p>
        </>
      ),
    },
    {
      title:
        "What’s the difference between drama classes and public speaking workshops for primary & secondary school kids?",
      content: (
        <>
          <p className="p-1 text-lg font-bold">
            🎭 Drama vs. Public Speaking: What’s the Difference?
          </p>
          <p className="p-1">
            While both drama and public speaking boost confidence, our workshops
            focus on structured communication: eye contact, vocal projection,
            persuasive delivery, and audience engagement. Drama emphasizes
            performative elements and character intepretation & acting, while
            public speaking empowers your child to express real thoughts clearly
            and effectively in the majority of speech settings whereas
            dramaticised speech is restricted to mainly theatre stages.
          </p>
        </>
      ),
    },
    {
      title:
        "Top-rated weekend & weekday public speaking courses in Singapore for secondary & primary school students",
      content: (
        <>
          <p className="p-1 text-lg font-bold">
            ⭐ Weekend & Weekdays Confidence Building Classes
          </p>
          <p className="p-1">
            Our Speech Excellence Program™ for primary & secondary students run
            every Wednesday, Thursday, Friday, Saturday and Sunday. Our S’Peak
            Performance Kids Holiday Program™ and Interview Skills Mastery™ run
            on weekdays during the school holiday periods. Taught by
            professional speakers well-versed in our methodologies and
            pedagogies, handpicked and personally trained by our founder Darren
            Tay (2016 World Champion of Public Speaking), our courses and
            holiday workshops consistently receive 5-star reviews from parents
            and students because of the quality of our training & trainers (we
            are not a franchise and have absolute control over the training &
            trainers’ standards). Topics include persuasive speeches, debate,
            interview prep, and impromptu speaking.
          </p>
        </>
      ),
    },
    {
      title:
        "Which public speaking schools in Singapore run national-level competitions for students and trusted by MOE schools’ continued participation over many years?",
      content: (
        <>
          <p className="p-1 text-lg font-bold">
            💬 National-level platform provided for competitive speaking
          </p>
          <p className="p-1">
            Public Speaking Academy Singapore is the official organizer of the
            annual National Public Speaking Competition — one of Singapore’s
            largest student public speaking contests (As of the year (2017), the
            National Public Speaking Competition entered the Singapore Book of
            Records as the largest public speaking competition in Singapore for
            secondary school students) – that is trusted by more than 50 MOE
            Schools through continued participation for 14 years straight. The
            competition attracts participants from MOE primary and secondary
            schools, offering students a national platform to showcase their
            oratory and persuasive speaking skills. The GOOD NEWS? All our
            centres’ students, existing or past, will be eligible to participate
            for free. Check out{" "}
            <a
              className="text-btnColor"
              href="https://www.youtube.com/@PublicSpeakingAcademyPteLtd"
            >
              our YouTube channel
            </a>{" "}
            to find the speeches and highlight reels of past editions!
          </p>
        </>
      ),
    },
    {
      title: "How to overcome public speaking anxiety and build confidence",
      content: (
        <>
          <p className="p-1 text-lg font-bold">
            💬 Essential blend: Theory (techniques), Practice (the right
            approach), Guidance (experienced trainers with perceptive
            evaluation)
          </p>
          <p className="p-1">
            Just a guidebook or textbook on public speaking is not going to
            work. A public speaking workshop, presentation course/ programme can
            help — like our S’Peak Performance Kids Holiday Program™ is a 2-day
            intensive masterclass on public speaking, tailored for young
            communicators looking for a deep-dive into the knowledge,
            techniques, and tips for public speaking. It extracts 6 core areas
            from our extensive public speaking syllabus for a focused and
            tailored programme for students (e.g., Interview Skills,
            Story-Telling, Stage Confidence). This public speaking school
            holiday program uses exposure therapy (from multiple break-out
            sessions in front of smaller crowds, to culminating in the final
            presentation in front of a bigger crowd), structured practice, and
            expert feedback{" "}
            <a
              className="text-btnColor"
              href="https://www.publicspeakingacademy.com.sg/master-trainer/"
            >
              (trainers’ profile)
            </a>{" "}
            to build confidence over time. We strive to impart actionable
            techniques, provide practical opportunities for application and
            assimilation of techniques to better manage the relationship with
            stage/ speaking anxiety.
          </p>
        </>
      ),
    },
  ];

  return (
    <>
      <Helmet>
        <title>
          School Holiday Public Speaking Program for Children | Public Speaking
          Academy
        </title>
        <meta
          name="description"
          content="Led by Darren Tay, our public speaking training course coaches you effective communication and presentation skills in group. Contact us at 6443 4049 today!"
        ></meta>
      </Helmet>

      <section id="breadcrumb" className="bg-[#F5F5FC] py-1">
        <div className="container mx-auto">
          <div className="flex justify-between mx-3">
            <div>S’PEAK PERFORMANCE PROGRAMME (KIDS)</div>
            <div>
              Home / Courses & Programs / Public Speaking for Kids / Holiday
              Camps/Masterclasses
            </div>
          </div>
        </div>
      </section>

      <section id="block-1" className="mx-3">
        <div class="container mx-auto py-20">
          <div class="flex flex-col lg:flex-row pt-5 space-x-10">
            <div class="w-full lg:w-2/3">
              <h1 class="font-primary text-3xl font-bold text-primary uppercase">
                SCHOOL HOLIDAY PUBLIC SPEAKING PROGRAMME FOR CHILDREN
              </h1>
              <h2 class="font-primary text-xl lg:text-2xl font-bold text-primary uppercase py-5">
                A 2-DAY INTENSIVE, PUBLIC SPEAKING HOLIDAY CAMP FOR KIDS
              </h2>
              <div>
                <img
                  src="/images/Kids intensive - featured pic-min.png"
                  alt=""
                />

                <p class="py-5 font-text text-lg">
                  Public speaking and in-class presentation can be daunting, and
                  finding the right holiday camp/ workshop for your child is
                  even more of a challenge. A regular, weekly course may be a
                  big commitment for your child. We have an alternative –{" "}
                  <strong>S’Peak Performance Program (SPP)</strong> Kids Public
                  Speaking Holiday Camp! Whether you are looking for a quick,
                  deep-dive into public speaking and presentation skills for
                  your budding communicator or want your child to explore public
                  speaking for the first time, our S’Peak Performance Programme
                  (Public Speaking Academy’s{" "}
                  <strong>signature kids school holiday camp</strong> – running{" "}
                  <strong>since 2016!</strong>) is a strong option for you!
                </p>
                <img
                  src="/images/public-speaking-course-for-adults-public-speaking-courses-for-adults-public-speaking-for-adults-2-1.png"
                  alt=""
                />
                <p class="pb-5 pt-5 text-xl font-bold">
                  Introducing our S’Peak Performance Holiday Programme (a public
                  speaking holiday camp for Children ages 9 to 12 & 13 to 18)
                </p>
                <p class="pb-5 font-text text-lg">
                  The S’Peak Performance Programme is a 2-day intensive course/
                  workshop on public speaking and communication skills, tailored
                  for young communicators looking for a deep-dive into the
                  knowledge, techniques, and tips for public speaking. We have
                  extracted 6 core areas from our extensive public speaking
                  training syllabus for a focused and tailored programme for
                  your child (e.g., Interview Skills, Story-Telling, Stage
                  Confidence). The SPP kids school holiday camp is helmed
                  personally by our Master Trainer and World Champion of Public
                  Speaking 2016, Darren Tay (assisted by Senior Trainer).
                </p>
              </div>
              <div className="mx-auto">
                <h3 class="font-primary text-3xl font-bold text-primary text-center py-5">
                  The Public Speaking Camp & Spark Your Child Needs This School
                  Holiday!
                </h3>
                <div className="p-5 bg-blue-200 rounded-md ">
                  <h3 class="font-primary text-xl font-bold text-primary text-center">
                    Theory Building
                  </h3>
                  <p className="text-lg text-center ">
                    Learners receive the printed proprietary materials and are
                    guided through the techniques by our professional trainers,
                    with engagement tools (e.g., quizzes, discussions,
                    challenges), throughout the 2-day holiday classes
                  </p>
                </div>
                <div className="my-2">
                  <svg
                    className="mx-auto text-center"
                    width="24"
                    height="58"
                    viewBox="0 0 24 58"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.9393 57.0607C11.5251 57.6464 12.4749 57.6464 13.0607 57.0607L22.6066 47.5147C23.1924 46.9289 23.1924 45.9792 22.6066 45.3934C22.0208 44.8076 21.0711 44.8076 20.4853 45.3934L12 53.8787L3.51472 45.3934C2.92893 44.8076 1.97918 44.8076 1.3934 45.3934C0.807609 45.9792 0.807609 46.9289 1.3934 47.5147L10.9393 57.0607ZM10.5 -6.55671e-08L10.5 56L13.5 56L13.5 6.55671e-08L10.5 -6.55671e-08Z"
                      fill="black"
                    />
                  </svg>
                </div>
                <div className="p-5 bg-blue-200 rounded-md ">
                  <h3 class="font-primary text-xl font-bold text-primary text-center">
                    Breakout Practice
                  </h3>
                  <p className="text-lg text-center ">
                    Our young communicators are given a safe space to explore
                    the techniques and apply the theory in multiple,
                    small-scale, and engaging break-out sessions, peppered
                    throughout the 2-day holiday classes
                  </p>
                </div>
                <div className="my-2">
                  <svg
                    className="mx-auto text-center"
                    width="24"
                    height="58"
                    viewBox="0 0 24 58"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.9393 57.0607C11.5251 57.6464 12.4749 57.6464 13.0607 57.0607L22.6066 47.5147C23.1924 46.9289 23.1924 45.9792 22.6066 45.3934C22.0208 44.8076 21.0711 44.8076 20.4853 45.3934L12 53.8787L3.51472 45.3934C2.92893 44.8076 1.97918 44.8076 1.3934 45.3934C0.807609 45.9792 0.807609 46.9289 1.3934 47.5147L10.9393 57.0607ZM10.5 -6.55671e-08L10.5 56L13.5 56L13.5 6.55671e-08L10.5 -6.55671e-08Z"
                      fill="black"
                    />
                  </svg>
                </div>
                <div className="p-5 bg-blue-200 rounded-md ">
                  <h3 class="font-primary text-xl font-bold text-primary text-center">
                    Graduation Showcase
                  </h3>
                  <p className="text-lg text-center ">
                    Learners combine the knowledge and skills gained over the
                    2-day course in crafting a final showcase presentation,
                    presented to the full cohort
                  </p>
                </div>
                <div>
                  <p class="py-8 font-text text-lg">
                    The SPP holiday camp’s syllabus focuses on 6 communication &
                    public speaking domains that apply to our young learners’
                    day-to-day in school, at home, and even in the future. From
                    speech-crafting techniques to interview skills that we will
                    be imparting in this holiday workshop, your child will
                    explore the broad techniques and tips with the guidance of
                    Singapore’s first Public Speaking World Champion and our
                    experienced senior trainers:
                  </p>
                </div>

                <div className="py-5">
                  <h2 class="text-center text-xl font-bold pb-1">
                    The Programme Syllabus
                  </h2>
                  <h2 class="text-center text-4xl font-bold uppercase text-primary pb-1">
                    6 communication domains
                  </h2>
                  <h3 class="text-center text-xl font-bold uppercase text-primary pb-1">
                    (CORE FOCUS THROUGHOUT THE 2-DAY HOLIDAY CAMP)
                  </h3>
                  <div className="flex flex-col lg:flex-row space-y-10 lg:space-y-0 lg:space-x-5 my-14">
                    <div className="w-full lg:w-1/3">
                      <div className="px-3 py-5 border border-dashed border-cyan-200 bg-cyan-100 rounded-2xl">
                        <div className="-mt-8">
                          <p className="px-2 py-2 font-bold text-center text-white rounded-md text-md bg-primary font-primary">
                            Body Language
                          </p>
                        </div>
                        <div className="py-6 font-bold text-md font-text text-textColor">
                          <p className="py-2 text-center">
                            In this camp, explore & learn foundational body
                            langauge and vocal variety elements.
                          </p>
                          <div className="flex flex-row">
                            <ul className="px-2 list-none">
                              <li>Stage Positioning</li>
                              <li>Power Poses</li>
                              <li>Vocal Variety</li>
                              <li>Eye Contact</li>
                            </ul>
                            <ul className="px-2 list-none">
                              <li>Power Pauses</li>
                              <li>Audience Survey & Participation</li>
                              <li>Facial Expressions</li>
                              <li>Articulation</li>
                              <li>Linguistics</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="w-full lg:w-1/3">
                      <div className="px-3 py-5 bg-orange-100 border border-orange-200 border-dashed rounded-2xl">
                        <div className="-mt-8">
                          <p className="px-2 py-2 font-bold text-center text-white bg-orange-600 rounded-md text-md font-primary">
                            In - Class Presentation
                          </p>
                        </div>
                        <div className="py-6 font-bold text-md font-text text-textColor">
                          <p className="py-2 text-center">
                            In this camp, learn how to enliven in-class
                            presentations to engage the audience
                          </p>
                          <div className="">
                            <ul className="text-center list-none">
                              <li>Story-Crafting</li>
                              <li>Speech Structure</li>
                              <li>Presenting with visual aids</li>
                              <li>Edge of the Seats: 8 Step Blueprint</li>
                              <li>Audience Engagement</li>
                              <li>Engagement</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="w-full lg:w-1/3">
                      <div className="px-3 py-5 border border-dashed border-cyan-200 bg-cyan-100 rounded-2xl">
                        <div className="-mt-8">
                          <p className="px-2 py-2 font-bold text-center text-white rounded-md text-md bg-primary font-primary">
                            Charisma + Dealing With Stage Fright
                          </p>
                        </div>
                        <div className="py-6 font-bold text-md font-text text-textColor">
                          <p className="py-2 text-center">
                            In this camp, learn to manage and tackle stage
                            fright/anxiety with charisma
                          </p>
                          <div className="">
                            <ul className="text-center list-none">
                              <li>Advanced Power Poses</li>
                              <li>Visualization for Stage Confidence</li>
                              <li>Rehearsing, Practising Tips</li>
                              <li>Charisma-Building</li>
                              <li>Mindfulness Practice</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-col lg:flex-row space-y-10 lg:space-y-0 lg:space-x-5 my-14">
                    <div className="w-full lg:w-1/3">
                      <div className="px-3 py-5 bg-orange-100 border border-orange-200 border-dashed rounded-2xl">
                        <div className="-mt-8">
                          <p className="px-2 py-2 font-bold text-center text-white bg-orange-600 rounded-md text-md font-primary">
                            Interview Mastery
                          </p>
                        </div>
                        <div className="py-6 font-bold text-md font-text text-textColor">
                          <p className="py-2 text-center">
                            In this camp, master interview common questions with
                            confidence
                          </p>
                          <div className="">
                            <ul className="text-center list-none">
                              <li>Interview Preparation</li>
                              <li>Top 10 Toughest Interview Questions</li>
                              <li>Acing Group Interviews</li>
                              <li>Answering Techniques</li>
                              <li>Persuasion & Follow-Up</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="w-full lg:w-1/3">
                      <div className="px-3 py-5 border border-dashed bg-cyan-100 border-cyan-200 rounded-2xl">
                        <div className="-mt-8">
                          <p className="px-2 py-2 font-bold text-center text-white rounded-md bg-primary text-md font-primary">
                            Impromptu Speaking
                          </p>
                        </div>
                        <div className="py-6 font-bold text-md font-text text-textColor">
                          <p className="py-2 text-center">
                            In this camp, learn to think and respond
                            off-the-cuff in managing impromptu settings
                          </p>
                          <div className="">
                            <ul className="text-center list-none">
                              <li>Tell a Captivating Story and Make a Point</li>
                              <li>Use Interrogative Pronouns</li>
                              <li>Past, Present, Future model</li>
                              <li>Pendulum Method</li>
                              <li>P.E.E.L Approach</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="w-full lg:w-1/3">
                      <div className="px-3 py-5 bg-orange-100 border border-orange-200 border-dashed rounded-2xl">
                        <div className="-mt-8">
                          <p className="px-2 py-2 font-bold text-center text-white bg-orange-600 rounded-md text-md font-primary">
                            Oral Exam
                          </p>
                        </div>
                        <div className="py-6 font-bold text-md font-text text-textColor">
                          <p className="py-2 text-center">
                            In this camp, learn how to apply public speaking
                            techniques to Oral Examination settings
                          </p>
                          <div className="">
                            <ul className="text-center list-none">
                              <li>Pronunciation & Enunciation</li>
                              <li>Diction, Tonality, Context</li>
                              <li>Fluency, Purpose, Expressiveness</li>
                              <li>Development of Rich Points</li>
                              <li>Mastering Question Types</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-white p-2 md:p-10 mt-10 rounded-3xl">
                  <div className="mb-10">
                    <h1 className="divider text-primary font-primary font-bold uppercase text-2xl md:text-3xl">
                      Frequently Asked Questions (FAQs)
                    </h1>
                  </div>
                  <AccordionList items={faqData} />
                </div>

                <section id="review">
                  <div className="w-full py-5 my-5 bg-slate-100 rounded-xl">
                    <div className="pt-10 pb-5">
                      <h2 className="text-xl font-bold text-center font-primary">
                        What Our Students Have To Say About Their Transformative
                        Experience From This Camp:
                      </h2>
                    </div>
                    <div className="flex flex-col px-5 md:flex-row">
                      <div className="px-5 pb-10 md:w-1/2">
                        <div className="aspect-video">
                          <iframe
                            class="w-full h-full"
                            src="https://www.youtube.com/embed/cbRctQf0cv8"
                            title="YouTube video player"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen
                          ></iframe>
                        </div>
                      </div>
                      <div className="px-5 pb-10 md:w-1/2">
                        <div className="aspect-video">
                          <iframe
                            class="w-full h-full"
                            src="https://www.youtube.com/embed/J1BZp26CXV4"
                            title="YouTube video player"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen
                          ></iframe>
                        </div>
                      </div>
                    </div>
                    <section className="my-10">
                      <h1 className="text-2xl font-bold mb-6 text-center">
                        Testimonials & Reviews
                      </h1>
                      <h2 className="text-lg font-bold mb-6 text-center lg:px-10 px-5">
                        Below are some actual, verbatim & verifiable Google
                        reviews/ client testimonials extracted from our Google
                        Business page (available{" "}
                        <a
                          className="text-btnColor"
                          href="https://www.google.com/search?q=public+speaking+academy&sca_esv=b0ca21e5797e63e2&sxsrf=AE3TifPBB0t81EH94Y1iP2pUPWX0L6-vsg%3A1748515259444&source=hp&ei=uzk4aNX3GI674-EPjM_9mAg&iflsig=AOw8s4IAAAAAaDhHy6T9EiLASTavAV2pmD2fJ9M80zcZ&gs_ssp=eJzj4tVP1zc0TDcoLiqzjM8yYLRSNagwNkxJNE5JNjJPMbSwSDYytjKoSLFIMzdKskyxTEkyMTA0NvMSLyhNyslMViguSE3MzsxLV0hMTkxJza0EAJKvGFM&oq=&gs_lp=Egdnd3Mtd2l6IgAqAggAMg0QLhjHARgnGOoCGK8BMgcQIxgnGOoCMgcQIxgnGOoCMgcQIxgnGOoCMgcQIxgnGOoCMgcQIxgnGOoCMg0QLhjHARgnGOoCGK8BMgcQIxgnGOoCMg0QIxjwBRgnGMkCGOoCMgcQIxgnGOoCSOEEUABYAHABeACQAQCYAQCgAQCqAQC4AQHIAQCYAgGgAg2oAgqYAw3xBYGuWQ1nM3TnkgcBMaAHALIHALgHAMIHAzMtMcgHCg&sclient=gws-wiz#lrd="
                        >
                          here
                        </a>
                        )
                      </h2>

                      <TestimonialGrid testimonials={testi} />
                      <h2 className="text-lg font-bold mb-6 text-center lg:px-10 px-5 pt-4 pb-10">
                        …and more!
                      </h2>
                    </section>
                  </div>
                </section>

                <section id="block-3">
                  <div>
                    <p class="text-2xl font-bold py-2 italic">
                      SPP Kids School Holiday Camp Details - How Do I Enrol My
                      Child?
                    </p>
                    <p class="pb-5 font-text text-lg">
                      The S’Peak Performance Programme is only conducted at our
                      SAFRA Tampines Branch (1A Tampines Street 92 #01-13B
                      (SAFRA Tampines) Singapore-528882), with the following
                      schedule (1 free lunch provided per day during the camp,
                      per pax):
                    </p>
                  </div>
                  <div className="flex flex-row space-x-5">
                    <div className="w-1/2 py-5 rounded-lg bg-cyan-50">
                      <h2 className="text-xl font-bold text-center font-primary">
                        For 9 to 12 years old side (2 intakes)
                      </h2>
                      <h3 className="text-lg text-center font-primary">
                        Primary School Group
                      </h3>
                      <div className="py-5 text-center">
                        <p className="font-bold">
                          5 & 6 June 2025 (Thur & Fri)
                        </p>
                        <p>9.30 am to 6.00 pm on both days</p>
                        <p className="font-bold text-red-600">
                          Open for Registration!
                        </p>
                      </div>
                    </div>
                    <div className="w-1/2 py-5 bg-orange-100 rounded-lg">
                      <h2 className="text-xl font-bold text-center font-primary">
                        For 13 to 18 years old side (2 intakes)
                      </h2>
                      <h3 className="text-lg text-center font-primary">
                        Sec School/Teen Group
                      </h3>
                      <div className="py-5 text-center">
                        <p className="font-bold">
                          12 & 13 June 2025 (Thur & Fri)
                        </p>
                        <p>9.30 am to 6.00 pm on both days</p>
                        <p className="font-bold text-red-600">
                          Open for Registration!
                        </p>
                      </div>
                    </div>
                  </div>
                  <p class="py-5 font-text text-lg text-center font-bold">
                    (doors open for attendance from 9 to 9.30 am for both
                    sessions, with class starting strictly at 9.30 am)
                  </p>
                  <div className="w-full p-5 my-10 bg-gray-100 rounded-lg">
                    <h2 className="text-xl font-bold text-center font-primary">
                      Price Details
                    </h2>
                    <h3 className="py-3 text-2xl text-center font-text">
                      We are offering a limited seats-only rate of – S$549 nett
                    </h3>
                    <h3 className="text-lg text-center font-text">
                      We are offering a limited seats-only rate of – S$549 nett
                      (all materials, evaluation, certificates included)
                    </h3>
                  </div>
                  <div className="my-10 text-center">
                    <NavLink
                      className="px-4 py-4 text-md lg:text-xl font-bold text-white font-primary bg-btnColor rounded-xl inline-block"
                      to="https://docs.google.com/document/d/1vRGposm0rlhUid5RJZVUv-2_trEvyQtkdFKyVe3apsA/edit?usp=sharing"
                    >
                      Click here to book your slot! (instructions on next page)
                    </NavLink>
                  </div>
                </section>
                <section>
                  <h2 className="my-10 text-2xl font-bold text-center">
                    Other Key Programme Details
                  </h2>

                  <div className="flex flex-row items-center border-t border-gray-200">
                    <div className="w-1/3 p-5 font-bold text-center bg-white text-textColor">
                      Where is the class conducted?
                    </div>
                    <div className="w-2/3 p-5 bg-gray-100 text-textColor">
                      <b>SAFRA TAMPINES BRANCH</b>
                      <br />
                      Public Speaking Academy @ Tampines <br />
                      1A Tampines Street 92 #01-13B <br />
                      SAFRA Tampines <br />
                      Singapore-528882.
                    </div>
                  </div>
                  <div className="flex flex-row items-center border-t border-gray-200">
                    <div className="w-1/3 p-5 font-bold text-center bg-white text-textColor">
                      What is the class size?
                      <br />
                      Can I attend a trial?
                    </div>
                    <div className="w-2/3 p-5 bg-gray-100 text-textColor">
                      Maximum class size of 17 students – as this is an
                      intensive programme with limited capacity, there is no
                      trial class. Likewise, only enrolled students will be
                      allowed to sit in for the programme to ensure a
                      constructive and safe learning environment.
                    </div>
                  </div>
                  <div className="flex flex-row items-center border-t border-gray-200">
                    <div className="w-1/3 p-5 font-bold text-center bg-white text-textColor">
                      Who are the Trainers?
                    </div>
                    <div className="w-2/3 p-5 bg-gray-100 text-textColor">
                      The programme will be helmed by our Principal/ World
                      Champion of Public Speaking Mr Darren Tay, and our senior
                      trainer (with each Trainer taking one day each)
                    </div>
                  </div>
                  <div className="flex flex-row items-center border-t border-gray-200">
                    <div className="w-1/3 p-5 font-bold text-center bg-white text-textColor">
                      What if My child Misses a Class or needs to leave early?
                    </div>
                    <div className="w-2/3 p-5 bg-gray-100 text-textColor">
                      There is no replacement for the missed session or a
                      refund/pro-rate for the session/portions missed. We
                      recommend parents/students to confirm their availability
                      for the full programme before signing up (you may instead
                      consider our regular public speaking programme).
                    </div>
                  </div>
                  <div className="flex flex-row items-center border-y border-gray-200">
                    <div className="w-1/3 p-5 font-bold text-center bg-white text-textColor">
                      How are your classes conducted with the present COVID-19
                      situation?
                    </div>
                    <div className="w-2/3 p-5 bg-gray-100 text-textColor">
                      Our programmes are conducted with proper clearance from
                      the relevant Government authorities (Ministry of Education
                      and EnterpriseSG). We also abide by our Safety Management
                      Plan which measures such as safe distancing, mandatory
                      mask-wearing, temperature-taking etc. (feel free to
                      request for a copy of our Safety Management Plan).
                      <br />
                      <br />
                      In the event of any COVID-19 measures, legislation, or any
                      directive from the Government disrupting the conduct of
                      the programme, there will be no refund of the fees paid.
                      Instead, the programme will be postponed to another
                      date/time (as per our Terms & Conditions in our
                      Registration Form).
                    </div>
                  </div>
                </section>
                <section>
                  <h2 className="my-10 text-2xl font-bold text-center">
                    Find out more about our Track Record since 2009!
                  </h2>
                  <img
                    className="my-3"
                    src="/images/image showing satisfied corporate clients of s'peak performance public speaking skills training program-min.png"
                    alt=""
                  />
                  <img
                    className="my-3 text-center"
                    src="/images/public-speaking-course-for-adults-public-speaking-courses-for-adults-public-speaking-for-adults-3-3.jpg"
                    alt=""
                  />
                </section>
                <section>
                  <div className="my-10">
                    <p class="text-lg font-bold pb-5">
                      Enrich Your Child/ Children’s Skillset This School
                      Holiday! 😊
                    </p>
                    <p class="font-text text-lg">
                      Register for our school holiday camp NOW by clicking the
                      button below! (you will be brought to a page with details
                      on how to register and make payment).
                    </p>
                    <div className="my-10 text-center">
                      <NavLink
                        className="px-4 py-4 text-md lg:text-xl font-bold text-white font-primary bg-btnColor rounded-xl inline-block"
                        to="https://docs.google.com/document/d/1vRGposm0rlhUid5RJZVUv-2_trEvyQtkdFKyVe3apsA/edit?usp=sharing"
                      >
                        Click here to book your slot! (instructions on next
                        page)
                      </NavLink>
                    </div>
                    <p class="text-lg font-bold py-3">
                      If you have any queries before signing up, please send us
                      an email (to: contact@publicspeakingacademy.com.sg) with
                      “SPP 2025 Kids” in the email header and we will get back
                      to you on your query!
                    </p>
                    <p class="font-text text-lg py-3">
                      If you are keen to develop your child into a confident,
                      competent, and creative speaker/communicator/leader these
                      school holidays, join us for the S’Peak Performance
                      Programme (our signature Public Speaking Holiday Camp for
                      Kids aged 9-18)! Our founder, and 2016 World Champion of
                      Public Speaking Darren Tay, looks forward to sharing his
                      tried and tested know-hows, techniques, and experiences
                      with your child/children, in his signature school holiday
                      camp, to help your child enhance his/ her presentation
                      abilities and boost your child/ children’s public speaking
                      confidence!
                    </p>
                    <p class="font-text text-lg py-3">
                      If you are also looking for public speaking courses or
                      holiday workshop for yourself (adults), you may check out
                      our{" "}
                      <NavLink
                        className="font-text text-lg text-btnColor hover:underline"
                        to="/courses-and-programs"
                      >
                        public speaking courses for adults here.
                      </NavLink>
                    </p>
                  </div>
                </section>

                <div className="bg-slate-50 p-2 md:p-10 ">
                  <div className=" mb-10">
                    <h1 className="divider text-primary font-primary font-bold uppercase text-2xl md:text-3xl">
                      END OF COURSE DETAILS
                    </h1>
                    <h1 className="text-slate-500 font-primary font-bold text-center text-xl md:text-2xl">
                      Quick Tips
                    </h1>
                  </div>

                  <div
                    tabIndex={0}
                    className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                  >
                    <div className="text-xl font-medium collapse-title text-btnColor">
                      😰 How to Overcome Fear of Public Speaking
                    </div>
                    <div className="collapse-content">
                      <p className="p-1">
                        Fear of public speaking is common—it’s often rooted in a
                        fear of judgment or making mistakes.
                      </p>
                      <p className="py-1">To manage it effectively:</p>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          1. Prepare thoroughly
                        </p>
                        <p className="font-text">
                          Knowing your material well builds confidence. Use
                          sign-posts throughout the speech to internalize its
                          structure well.
                        </p>
                      </div>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          2. Visualize success
                        </p>
                        <p className="font-text">
                          Shift your focus from negativity to picturing yourself
                          speaking calmly and clearly. Mental rehearsal matters.
                        </p>
                      </div>
                      <div className="py-1">
                        <p className="font-bold font-primary">3. Start small</p>
                        <p className="font-text">
                          Speak up in small meetings or practice with friends
                          before tackling bigger stages.
                        </p>
                      </div>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          4. Focus on your audience
                        </p>
                        <p className="font-text">
                          “Big Baby Pivot” – treating your audience as a “big
                          baby” that requires your full attention, instead of
                          focusing on yourself, shift it to how you can help or
                          inform others.
                        </p>
                      </div>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          5. Breathe and pause
                        </p>
                        <p className="font-text">
                          Take deep breaths (inhale while feeling the coolness
                          of the air, and exhale with pursed lips). Pausing
                          helps you think and eases nerves. Pause with sustained
                          eye contact to enhance the impact of your pauses.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    tabIndex={1}
                    className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                  >
                    <div className="text-xl font-medium collapse-title text-btnColor">
                      🧩 How to Organize a Speech Quickly
                    </div>
                    <div className="collapse-content">
                      <p className="p-1">
                        When time is tight, a solid structure saves the day. Use
                        the tried-and-true <b>“Point, Reason, Example”</b>{" "}
                        format.
                      </p>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          1. Start with your point
                        </p>
                        <p className="font-text">
                          What’s the key message or takeaway? One thing that
                          even if your audience forgets everything else BUT
                          <b>this!</b>
                        </p>
                      </div>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          2. Add your reason
                        </p>
                        <p className="font-bold font-text">
                          Why does it matter? Back it up with logic or context.
                        </p>
                      </div>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          3. Give an example
                        </p>
                        <p className="font-bold font-text">
                          Stories or real-life applications make your message
                          stick.
                        </p>
                      </div>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          4. Close with a recap
                        </p>
                        <p className="font-bold font-text">
                          Reinforce your main point and end confidently.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    tabIndex={2}
                    className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                  >
                    <div className="text-xl font-medium collapse-title text-btnColor">
                      🧒 How to Help My Child Speak More Confidently
                    </div>
                    <div className="collapse-content">
                      <p className="p-1">
                        Building speaking confidence in kids starts with a safe
                        space and the right encouragement.
                      </p>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          1. Praise effort, not just performance
                        </p>
                        <p className="font-text">
                          Celebrate the act of speaking up, even if it’s
                          imperfect. E.g. “I see progress! Progress over
                          perfection, ok?”
                        </p>
                      </div>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          2. Practice through play
                        </p>
                        <p className="font-text">
                          Role-play, storytelling, or pretend news reporting
                          makes speaking fun.
                        </p>
                      </div>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          3. Let them lead conversations
                        </p>
                        <p className="font-text">
                          Encourage your child to initiate and order food, greet
                          guests, or ask questions in public.
                        </p>
                      </div>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          4. Set small speaking goals
                        </p>
                        <p className="font-text">
                          Start with a short sentence, then a short personal
                          recount, then a presentation.
                        </p>
                      </div>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          5. Enroll in a supportive program
                        </p>
                        <p className="font-text">
                          Group classes designed for kids can provide coaching
                          and peer encouragement.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    tabIndex={3}
                    className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                  >
                    <div className="text-xl font-medium collapse-title text-btnColor">
                      👪 Is Public Speaking Good for Kids?
                    </div>
                    <div className="collapse-content">
                      <p className="p-1">
                        Yes—public speaking is one of the most valuable life
                        skills a child can build.
                      </p>
                      <p className="py-1">Here’s why:</p>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          1. Builds confidence
                        </p>
                        <p className="font-text">
                          Kids learn to speak up, reduce fear of rejection/
                          objection, even in unfamiliar settings.
                        </p>
                      </div>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          2. Improves communication
                        </p>
                        <p className="font-text">
                          They become better listeners and more thoughtful
                          speakers.
                        </p>
                      </div>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          3. Sharpens thinking
                        </p>
                        <p className="font-text">
                          Organizing ideas and expressing opinions boosts
                          critical thinking.
                        </p>
                      </div>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          4. Encourages leadership
                        </p>
                        <p className="font-text">
                          Strong speakers often become natural leaders in school
                          and beyond.
                        </p>
                      </div>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          5. Prepares them for interviews and exams
                        </p>
                        <p className="font-text">
                          Verbal communication is a key part of academic/ future
                          career success.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    tabIndex={4}
                    className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                  >
                    <div className="text-xl font-medium collapse-title text-btnColor">
                      📅 Best School Holiday Programs for Kids in Singapore
                    </div>
                    <div className="collapse-content">
                      <p className="p-1">
                        Looking for enriching activities during school breaks?
                        Here’s what to consider:
                      </p>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          1. Skill-building focus
                        </p>
                        <p className="font-text">
                          Choose programs that develop holistic life skills like
                          communication in various settings (impromptu speech,
                          storytelling, interview, oral exam, class
                          presentation).
                        </p>
                      </div>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          2. Progressive learning and exposure
                        </p>
                        <p className="font-text">
                          Children thrive in settings where they won’t get
                          thrown into the deep end of the water; breaking into
                          smaller groups to present before culminating in the
                          bigger audience will be more receptive.
                        </p>
                      </div>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          3. Engaging curriculum
                        </p>
                        <p className="font-text">
                          Look for activities that balance fun with learning.
                        </p>
                      </div>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          4. Safe and supportive environment
                        </p>
                        <p className="font-text">
                          Make sure instructors are trained and experienced with
                          children.
                        </p>
                      </div>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          5. Tangible takeaways
                        </p>
                        <p className="font-text">
                          Kids should walk away more confident, capable, and
                          inspired.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div
                    tabIndex={5}
                    className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                  >
                    <div className="text-xl font-medium collapse-title text-btnColor">
                      📖 Storytelling Techniques for Public Speaking
                    </div>
                    <div className="collapse-content">
                      <p className="p-1">
                        Great storytelling makes your message memorable and
                        emotional.
                      </p>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          1. Start with a hook
                        </p>
                        <p className="font-text">
                          Draw the audience in right away with a vivid moment or
                          conflict. E.g. A startling statistic, quotation, or
                          short story.
                        </p>
                      </div>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          2. Follow a structure
                        </p>
                        <p className="font-text">
                          Use the classic arc: beginning (set the scene and
                          characters), buildup (the obstacles and challenges
                          faced), climax (the tipping point), resolution (lesson
                          learnt).
                        </p>
                      </div>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          3. Keep it personal
                        </p>
                        <p className="font-text">
                          Authentic stories connect more than generic ones.
                        </p>
                      </div>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          4. Use descriptive language
                        </p>
                        <p className="font-text">
                          Help the audience see, hear, and feel what happened.
                          Show and not tell. “Creased eyebrows and flared
                          nostrils” to convey “I was angry”.
                        </p>
                      </div>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          5. End with meaning
                        </p>
                        <p className="font-text">
                          Tie your story back to your point or a lesson learned.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div
                    tabIndex={6}
                    className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                  >
                    <div className="text-xl font-medium collapse-title text-btnColor">
                      What do the best public speaking workshops for teenagers
                      in Singapore – effective & of quality - typically include?
                    </div>
                    <div className="collapse-content">
                      <p className="p-1">
                        Effective public speaking workshops for teenagers in
                        Singapore focus on three ingredients: T-H-B method –
                        Theory (techniques and strategies curated by 2016 first
                        Singaporean World Champion of Public Speaking), Hands-on
                        practice (actual application of the techniques every
                        lesson), Blindspot feedback (from seasoned public
                        speakers and experienced trainers).
                      </p>
                      <p className="p-1">
                        A public speaking holiday workshop or camp can help —
                        like our S’Peak Performance Kids Holiday Program™ which
                        is a 2-day intensive masterclass on public speaking,
                        tailored for young communicators looking for a deep-dive
                        into the knowledge, techniques, and tips for public
                        speaking. It extracts 6 core areas from our extensive
                        public speaking syllabus for a focused and tailored
                        programme for students (e.g., Interview Skills,
                        Storytelling, Stage Confidence-building). This public
                        speaking school holiday camp uses exposure therapy (from
                        multiple break-out sessions in front of smaller crowds,
                        to culminating in the final presentation in front of a
                        bigger crowd), structured practice, and expert feedback
                        (trainers’ profile) to build confidence over time. We
                        strive to impart actionable techniques, provide
                        practical opportunities for application and assimilation
                        of techniques to better manage the relationship with
                        stage/ speaking anxiety.
                      </p>
                      <p className="p-1">
                        For teenagers, they are at the adolescence phase where
                        they become more self-conscious and more sensitive to
                        being judged. Our trainers are competent when it comes
                        to engaging with & building rapport with teenagers,
                        teasing out the speaking confidence of the more reserved
                        ones, and yet able to challenge those who are more vocal
                        to enhance their speech delivery such as layering it
                        with body language cues and stage positioning.
                      </p>
                    </div>
                  </div>

                  <div
                    tabIndex={7}
                    className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                  >
                    <div className="text-xl font-medium collapse-title text-btnColor">
                      What do the best public speaking workshops for primary
                      school children in Singapore – effective & of quality -
                      typically include?
                    </div>
                    <div className="collapse-content">
                      <p className="p-1">
                        Effective public speaking workshops for primary school
                        kids (aged 7-8, 9-12) in Singapore focus on three
                        ingredients: T-H-B method – Theory (techniques and
                        strategies curated by 2016 first Singaporean World
                        Champion of Public Speaking), Hands-on practice (actual
                        application of the techniques every lesson), Blindspot
                        feedback (from seasoned public speakers and experienced
                        trainers).
                      </p>
                      <p className="p-1">
                        A public speaking holiday workshop or camp can help —
                        like our S’Peak Performance Kids Holiday Program™ which
                        is a 2-day intensive masterclass on public speaking,
                        tailored for young communicators looking for a deep-dive
                        into the knowledge, techniques, and tips for public
                        speaking. It extracts 6 core areas from our extensive
                        public speaking syllabus for a focused and tailored
                        programme for students (e.g., Interview Skills,
                        Storytelling, Stage Confidence-building). This public
                        speaking school holiday camp uses exposure therapy (from
                        multiple break-out sessions in front of smaller crowds,
                        to culminating in the final presentation in front of a
                        bigger crowd), structured practice, and expert feedback
                        (trainers’ profile) to build confidence over time. We
                        strive to impart actionable techniques, provide
                        practical opportunities for application and assimilation
                        of techniques to better manage the relationship with
                        stage/ speaking anxiety.
                      </p>
                      <p className="p-1">
                        For the young ones, you have a mix of two types of
                        budding speakers - 1) those who are uninitiated or due
                        to past bad experiences, they become self-conscious and
                        more sensitive to being judged or are naturally
                        introverted. Our trainers are competent when it comes to
                        engaging with & building rapport with young children,
                        teasing out the speaking confidence of the more reserved
                        ones with riveting stories and in-class activities, and
                        yet able to challenge those who are more vocal to
                        structure their thoughts better resulting in speeches
                        that are cogent and impactful.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="hidden md:inline md:w-1/3 px-5 pt-5 mb-10 border border-dashed rounded-lg">
              <Sidebar />
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}
